import React, { MouseEvent, ReactNode, useEffect, useState } from 'react';
import { Box } from 'theme-ui';

import DropdownIcon from '@src/assets/icons/dropdown.svg';

type DropdownProps = {
  children: ReactNode;
  customToggle?: ReactNode;
  listClassName?: string;
  onChange?: () => void;
  placeholder?: string;
};

export function Dropdown({
  onChange,
  placeholder,
  children,
  customToggle,
  listClassName = 'dropdown__list',
}: DropdownProps) {
  const [isListOpen, setIsListOpen] = useState(false);

  const closeDropdown = () => {
    setIsListOpen(false);
  };

  useEffect(() => {
    if (isListOpen) {
      window.addEventListener('click', closeDropdown);
    } else {
      window.removeEventListener('click', closeDropdown);
    }

    return () => {
      window.removeEventListener('click', closeDropdown);
    };
  }, [isListOpen]);

  const toggleList = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    const target = event.target as HTMLDivElement;
    const dropdownElement = target.closest('.dropdown');
    const openedList = dropdownElement?.querySelector('.dropdown__list');

    if (
      openedList &&
      document.documentElement.clientHeight <=
        openedList.getBoundingClientRect().bottom
    ) {
      openedList.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }

    setIsListOpen(!isListOpen);
  };

  return (
    <div
      className={isListOpen ? 'dropdown open' : 'dropdown'}
      onChange={onChange}
    >
      {placeholder && (
        <Box
          sx={{ fontSize: [2, 3, 3, 4] }}
          className="dropdown__frame"
          onClick={toggleList}
        >
          <Box className="dropdown__placeholder">{placeholder}</Box>
          <DropdownIcon
            className={isListOpen ? 'dropdown__icon open' : 'dropdown__icon'}
          />
        </Box>
      )}

      {customToggle && <div onClick={toggleList}>{customToggle}</div>}

      <ul className={listClassName}>{children}</ul>
    </div>
  );
}

type OptionProps = {
  children: ReactNode;
};

export function Option({ children }: OptionProps) {
  return <li className="dropdown__list-item">{children}</li>;
}
